import React, { Component } from 'react';
import LoadMask from "../../../Utils/LoadMask/LoadMask";
import CardSimple from '../../../Utils/Cards/cardSimple';
import ToolbarReportePrecioCliente from '../../../Utils/Toolbar/ToolbarReportePrecioCliente';
import GridPrecioCliente from './GridPrecioCliente';
import { Redirect } from 'react-router';
import ToolbarSimple from '../../../Utils/Toolbar/ToolbarSimple';


export default class ReportePreciocliente extends Component {

    render() {
        const { loader, permisos } = this.props;
        if(permisos.precios_cliente === false) {
            return <Redirect to={`/`} />
        }
        return (
            <CardSimple 
            titulo="REPORTE PRECIOS DE CLIENTES">
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <div className="col-md-12 row m-0 p-0 d-flex justify-content-md-end justify-content-center mt-0"
                        style={{border:"1px solid #E8E8E8", }}>
                        <div className="row col-12 m-0  inline-headers text-lg-left" style={{padding:"15px"}}>
                            <ToolbarReportePrecioCliente {...this.props} />
                            <ToolbarSimple
                                buscar={this.props.searchChange}
                                buscador={this.props.search}
                                placeholder={"Buscar por: Nombre"}
                            />
                        </div>
                    </div>
                    <br/>

                    <GridPrecioCliente
                        { ...this.props }
                    />

                </LoadMask>

            </CardSimple>
        )

    }
}
